// frontend/client/src/SocialPage.js
import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "./auth";
import "./SocialPage.css";

function SocialPage() {
  const { user } = useAuth();
  const [q, setQ] = useState("");
  const [loading, setLoading] = useState(false);
  const [users, setUsers] = useState([]);
  const [error, setError] = useState("");

  async function runSearch(term) {
    const t = (term || "").trim();
    if (!t) {
      setUsers([]);
      setError("");
      return;
    }

    setLoading(true);
    setError("");

    try {
      const res = await fetch(`/api/search-profiles?q=${encodeURIComponent(t)}`, {
        credentials: "include",
      });
      const data = await res.json().catch(() => null);

      if (!res.ok || !data || !data.ok) {
        setUsers([]);
        setError((data && data.error) || `HTTP ${res.status}`);
        return;
      }

      setUsers(Array.isArray(data.users) ? data.users : []);
    } catch {
      setUsers([]);
      setError("Network error");
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="dashboard-root">
      <div className="container">
        <header className="topbar">
          <div className="dashboard-title">GRADA · Social</div>

          <button
            className="profile-btn"
            type="button"
            onClick={() => (window.location.href = "/profile")}
          >
            <img
              src="/avatar"
              alt=""
              className="avatar"
              onError={(e) => (e.currentTarget.style.display = "none")}
            />
            <div>
              <div className="profile-name">{user?.fullName || user?.name}</div>
              <div className="profile-sub">{user?.university}</div>
            </div>
          </button>
        </header>

        <main>
          <div className="main-header-row">
            <div>
              <h2 className="main-title">Find friends</h2>
              <p className="main-sub">Search by name or email and open their profile.</p>
            </div>
          </div>

          <div className="feed-compose-card">
            <div className="feed-compose-title">Search profiles</div>

            <form
              onSubmit={(e) => {
                e.preventDefault();
                runSearch(q);
              }}
            >
              <input
                className="feed-comment-input"
                style={{ padding: "10px 12px", fontSize: 14 }}
                type="text"
                placeholder="Search by name or e-mail"
                value={q}
                onChange={(e) => setQ(e.target.value)}
              />

              <div className="feed-compose-actions" style={{ marginTop: 10 }}>
                <button className="feed-compose-btn" type="submit" disabled={loading}>
                  {loading ? "Searching..." : "Search"}
                </button>

                <button
                  className="feed-compose-btn-secondary"
                  type="button"
                  onClick={() => (window.location.href = "/dashboard")}
                >
                  Back
                </button>
              </div>
            </form>

            {error && (
              <div className="feed-empty" style={{ marginTop: 10 }}>
                {error}
              </div>
            )}

            {!error && !loading && q.trim() !== "" && users.length === 0 && (
              <div className="feed-empty" style={{ marginTop: 10 }}>
                No users found.
              </div>
            )}

            {users.length > 0 && (
              <div className="feed-list" style={{ marginTop: 12 }}>
                {users.map((u) => {
                  const id = u?.id;
                  return (
                    <div key={String(id ?? `${u.fullName}-${u.university}`)} className="feed-post" style={{ padding: "12px 0" }}>
                      <div className="feed-post-author">{u.fullName || "User"}</div>
                      <div className="feed-post-meta">
                        {u.university}
                      </div>
                      <div style={{ marginTop: 6 }}>
                        <Link
                          to={id ? `/user-profile?id=${encodeURIComponent(String(id))}` : "/dashboard"}
                          style={{ color: "#fbbf24", textDecoration: "none", fontSize: 12 }}
                        >
                          View profile
                        </Link>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </main>
      </div>
    </div>
  );
}

export default SocialPage;
